import { TestModuleComponent } from "./test-module/test-module.component";
import { NewProjectComponent } from './new-project/new-project.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCheck } from '../auth/auth.check';
import { LocatorHistoryComponent } from './locators/locator-history/locator-history.component';
import { LocatorComponent } from './locators/locator/locator.component';
import { StartComponent } from './start/start.component';
import { TestSuiteComponent } from "./test-suite/test-suite.component";
import { LocatorScreenComponent } from "./locator-screen/locator-screen.component";


const routes: Routes = [
  {
    path: "home",
    component: StartComponent,
    canActivate: [AuthCheck],
  },
  {
    path: "locator/:pid/:lid",
    component: LocatorComponent,
    canActivate: [AuthCheck],
  },
  {
    path: "history/:pid",
    component: LocatorHistoryComponent,
    canActivate: [AuthCheck],
  },
  {
    path : "module/:pid",
    component: TestModuleComponent,
    canActivate : [AuthCheck]
  },
  {
    path : "suite/:pid/:mid",
    component: TestSuiteComponent,
    canActivate : [AuthCheck]
  },
  {
    path : "screen/:pid/:mid",
    component: LocatorScreenComponent,
    canActivate : [AuthCheck]
  },
{
		path:'newproject', component: NewProjectComponent
		,canActivate:[AuthCheck]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectRoutingModule {}
